var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper d-flex flex-column"},[(_vm.currentUserId)?_c('Header',{staticClass:"layout-header"}):_vm._e(),_c('div',{staticClass:"layout-main"},[_vm._t("default")],2),(_vm.currentUserId)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }